import React, { useEffect, useState } from 'react'
import { FaEdit } from 'react-icons/fa'
import { MdDelete } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios"


const Videos = () => {
    const [data, setData] = useState([])
    const backUrl = process.env.REACT_APP_BACK_URL;

    const [showPopup, setShowPopup] = useState(false);
    const [selectedVideoId, setSelectedVideoId] = useState(null);


    const navigate = useNavigate()

    useEffect(() => {
        axios.get(`${backUrl}/admin/allvideos`)
            .then((res) => {
                console.log(res, "list of videos")
                if (Array.isArray(res.data)) {
                    setData(res.data.reverse());  // Only reverse if it's an array
                } else {
                    console.error('res.data is not an array');
                    setData([]);  // Optionally set an empty array or handle error
                }

            })
    }, [])




    const handleDeleteClick = (videoID) => {
        setSelectedVideoId(videoID);
        setShowPopup(true);
    };



    const handleConfirmDelete = () => {
        axios.post(`${backUrl}/admin/delvid`, { vid: selectedVideoId })
            .then((res) => {
                console.log(res, "")

                setShowPopup(false);
                setSelectedVideoId(null);
                window.location.reload();
                // setData(data.filter((item) => item.id !== selectedVideoId));

            })
    }

    const handleCancelDelete = () => {
        setShowPopup(false);
        setSelectedVideoId(null);
    };

    useEffect(() => {
        const Email = localStorage.getItem('Email');  // get name of cookies
        console.log(Email, "email recieved from localstorage");
        if (Email == null) {
            console.log("No email found")
            navigate('/')

        }

    }, [])
    return (
        <div className='md:min-h-screen md:pb-0 pb-10'>




            <div className="p-4 border-2 border-gray-200 border-dashed rounded-lg dark:border-gray-700">

                <div className="grid grid-cols-3 gap-4 mb-4">

                    <Link to="/add-video" className="flex items-center justify-center h-24 rounded bg-gray-50 dark:bg-gray-800">
                        <p className="text-2xl text-blue-950 dark:text-gray-500">
                            <svg className="w-3.5 h-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16" />
                            </svg>Add Youtube Video
                        </p>
                    </Link>


                </div>







            </div>


            <div className='mt-4'>
                <p className='text-md font-medium'>
                    All Videos
                </p>


                <div className="relative overflow-x-auto">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">

                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3">No.</th>
                                <th scope="col" className="px-6 py-3">Yt post ID</th>
                                <th scope="col" className="px-6 py-3">Yt Link </th>
                                <th scope="col" className="px-6 hidden py-3">Yt Post Title</th>
                                <th scope="col" className="px-6 py-3">Delete</th>
                                <th scope="col" className="px-6 py-3"></th>
                                {/* <th scope="col" className="px-6 py-3"></th> */}
                                {/* <th scope="col" className="px-6 py-3"></th> */}

                            </tr>
                        </thead>

                        <tbody>
                            {data?.map((item, index) => (
                                item ? (
                                    <tr className="bg-white text-blue-950 border-b dark:bg-gray-800 dark:border-gray-700">
                                        <td scope="row" className="px-6 py-3">{index + 1}</td>

                                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.videoID}</th>
                                        <td className="px-6 py-4">{item.link}</td>
                                        <td className="px-6 py-4 text-xl  text-red-500"><button onClick={() => handleDeleteClick(item.videoID)}><MdDelete /></button></td>

                                        <td className="px-6 py-4"></td>

                                        {/* <td className="px-6 py-4">Add</td> */}
                                        {/* <td className="px-6 py-4">Remove</td> */}
                                        <td className="px-6 py-4 hidden text-xl "><Link to=""><FaEdit /></Link></td>

                                    </tr>
                                ) : ""
                            ))}

                        </tbody>
                    </table>

                    {showPopup && (
                        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
                            <div className="bg-white p-6 rounded shadow-lg text-center">
                                <h2 className="text-lg mb-4">
                                    Are you sure you want to delete this news item?
                                </h2>
                                <p className="mb-4">News ID: {selectedVideoId}</p>
                                <div className="flex justify-center gap-4">
                                    <button
                                        onClick={handleConfirmDelete}
                                        className="px-4 py-2 bg-red-500 text-white rounded"
                                    >
                                        Yes, Delete
                                    </button>
                                    <button
                                        onClick={handleCancelDelete}
                                        className="px-4 py-2 bg-gray-300 text-black rounded"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

            </div>



        </div>

    )
}

export default Videos